import axios from 'axios'
import { COUNTRY } from '../../../const/constants'

export const saveReferido = async (formData: any, country: string) => {
  const fetchUrl = country !== COUNTRY.AR ? '/portaCreacion/referido' : '/psr/api/prospectos/item'
  let data
  if (country !== COUNTRY.AR) {
    const response = await axios.post(fetchUrl, {
      codigoPsr: formData.telefonoKiosco,
      documento: formData.document,
      entidadApp: formData.idAgente,
      mail: formData.mailProspecto,
      name: `${formData.nombreProspecto} ${formData.apellidoProspecto}`,
      nim: formData.telefonoProspecto,
      producto: formData.negocio
    })
    data = response.data
  } else {
    const response = await axios.post(`${fetchUrl}`, formData)
    data = response.data
  }
  return data
}

export const validateDuplicatedReferido = async (body: any) => {
  const fetchUrl = '/portaCreacion/validaDuplicados'
  const { data } = await axios.post(fetchUrl, body)
  return data
}
